module.exports = __webpack_public_path__ + "liveshare-icon-afdfdc07.jpg";